import React, { useContext } from 'react';

import { ISocialIframeProps } from './social-embed';
import { AmpPropsContext } from '../../context/amp-props/amp-props-provider';
import { IAmpPropsTag } from '../../typings/amp';
import { getAmpTag } from '../../utils/amp';
import { getSocialUrlParsed } from '../../utils/socials';
import AmpIframe from '../amp/amp-iframe';

const DEFAULT_WIDTH = '500';
const DEFAULT_HEIGHT = '800';
const SRC_PREFIX = 'https://www.facebook.com/plugins/post.php?href=';

const FacebookIframe: React.FC<ISocialIframeProps> = ({ src, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT }) => {
  const { ampProps } = useContext(AmpPropsContext);

  const ampFacebook: IAmpPropsTag | undefined = getAmpTag(ampProps, 'facebook');
  const srcParsed = getSocialUrlParsed(src, 'facebook');

  return ampFacebook ? (
    <AmpIframe
      src={`${SRC_PREFIX}${srcParsed}`}
      width={width}
      height={height}
      layout={ampFacebook.layout}
      dataBlockOnConsent={ampFacebook.dataBlockOnConsent}
    />
  ) : (
    <iframe
      src={src}
      width={width}
      height={height}
      style={{ border: 'none', overflow: 'hidden' }}
      scrolling="no"
      frameBorder="0"
      allowFullScreen
      allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
    />
  );
};

export default FacebookIframe;
